<template>
  <div :class="$style.container">
    <div :class="$style.content">
      <div :class="$style.item" @click="toCart">
        <img :class="$style.img" src="@assets/image/nav_cart.png" alt="" />
        <div v-if="isLogin && userInfo.shoppingCartCount > 0" :class="$style.num">{{ userInfo.shoppingCartCount > 99 ? '99+' : userInfo.shoppingCartCount  }}</div>
      </div>
      <div :class="$style.item" >
        <img :class="$style.img" src="@assets/image/nav_phone.png" alt="" />
      </div>
      <div :class="$style.item">
        <img :class="$style.img" src="@assets/image/nav_code.png" alt="" />
      </div>
      <div :class="$style.item" @click="backTop">
        <img :class="$style.img" src="@assets/image/nav_back.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "RightNav",
  data() {
    return {
      list: [],
    };
  },
  computed: {
    ...mapState("login", ["isLogin"]),
    ...mapState("user", ["userInfo"]),
  },
  methods: {
    toCart() {
      const link = this.isLogin ? "/cart" : "/login";
      this.$router.push(link);
    },
    backTop() {
      document.documentElement.scrollIntoView({ behavior: "smooth" });
    },
  },
  created() {
  },
};
</script>

<style lang="scss" module scoped>
.container {
  position: fixed;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);

  .item {
    width: rem(80);
    height: rem(80);
    @include flex();
    background-color: #91939a;
    transition: background-color 0.24;
    cursor: pointer;
    position: relative;
    .num{
      box-sizing: border-box;
        min-width: 18px;
        padding:0 5px;
        height: 18px;
        border-radius: 9px;
        color: #fff;
        font-size: 12px;
        background: #F9521f;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top:rem(13);
        right: rem(8);
    }

    &:not(:first-child) {
      border-top: $border-1;
    }

    &:hover {
      background-color: $theme-color;
      .num{
        border: 1px solid #fff;
      }
    }

    .img {
      width: rem(30);
      object-fit: cover;
    }
  }
}
</style>